import React, { useEffect, useState } from 'react';
import { AdminButton, AdminCard, AdminPageShell, AdminStatusPill, AdminTable } from '../AdminUI';

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:5000/api';

const NewAffiliateRequestsPage = () => {
  const token = localStorage.getItem('adminToken');
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [actionLoadingId, setActionLoadingId] = useState(null);

  const fetchItems = async () => {
    setLoading(true);
    setError('');
    try {
      const res = await fetch(`${API_BASE_URL}/admin/affiliates?status=pending&verified=true`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || 'Failed to load affiliate requests');
      setItems(data.affiliates || []);
    } catch (err) {
      setError(err.message || 'Failed to load affiliate requests');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchItems();
  }, []);

  const updateAffiliateStatus = async (affiliateId, action) => {
    setActionLoadingId(affiliateId);
    setError('');
    try {
      const res = await fetch(`${API_BASE_URL}/admin/affiliates/${affiliateId}/${action}`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}` }
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || `Failed to ${action} affiliate`);
      await fetchItems();
    } catch (err) {
      setError(err.message || `Failed to ${action} affiliate`);
    } finally {
      setActionLoadingId(null);
    }
  };

  return (
    <AdminPageShell
      title="New Affiliate Requests"
      description="Review incoming affiliate applications and approve or reject them."
    >
      {error ? <AdminCard className="border-rose-200 text-rose-600 dark:border-rose-900/40">{error}</AdminCard> : null}
      <AdminCard className="p-0">
        {loading ? (
          <div className="p-4 text-slate-500">Loading...</div>
        ) : (
          <AdminTable
            columns={[
              { key: 'username', label: 'Username' },
              { key: 'email', label: 'Email' },
              { key: 'country', label: 'Country', render: (row) => row.country || '-' },
              { key: 'verified', label: 'Verified', render: (row) => <AdminStatusPill value={row.email_verified ? 'verified' : 'unverified'} /> },
              { key: 'created_at', label: 'Joined', render: (row) => (row.created_at ? new Date(row.created_at).toLocaleString() : '-') },
              {
                key: 'actions',
                label: 'Actions',
                render: (row) => {
                  const isBusy = actionLoadingId === row.id;
                  return (
                    <div className="flex flex-wrap gap-2">
                      <AdminButton variant="secondary" className="px-2.5 py-1.5 text-xs" disabled={isBusy} onClick={() => updateAffiliateStatus(row.id, 'approve')}>
                        Approve
                      </AdminButton>
                      <AdminButton variant="danger" className="px-2.5 py-1.5 text-xs" disabled={isBusy} onClick={() => updateAffiliateStatus(row.id, 'reject')}>
                        Reject
                      </AdminButton>
                    </div>
                  );
                }
              }
            ]}
            rows={items}
            emptyMessage="No new affiliate requests."
          />
        )}
      </AdminCard>
    </AdminPageShell>
  );
};

export default NewAffiliateRequestsPage;
